import { Navbar } from "../components/Navbar";
import { Services } from "../components/Services";
import { Footer } from "../components/Footer";

export default function Pricing() {
  return (
    <main className="pt-16" data-testid="pricing-page">
      <Navbar />
      <Services />
      <Footer />
    </main>
  );
}
